const FLIGHT_ACTION_TYPES ={
  FETCH_FLIGHT_START:'FETCH_FLIGHT_START',
  FETCH_FLIGHT_SUCCESS: 'FETCH_FLIGHT_SUCCESS',
  FETCH_FLIGHT_FAILURE: 'FETCH_FLIGHT_FAILURE'
}

export default FLIGHT_ACTION_TYPES;